import React from 'react';
import './HorizontalContext.css';
import _ from 'lodash';

function HorizontalContextItem({ data, position, uniqueColor, columnExpandStateChangeCB }) {

    const [isHover, setIsHover] = React.useState(false);
    const [isCollapsed, setIsCollapsed] = React.useState(true);

    const hoverStart = e => {
        setIsHover(true);
    }
    const hoverEnd = e => {
        setIsHover(false);
    }
    const collapseItem = e => {
        columnExpandStateChangeCB(true);
        setIsCollapsed(true);
    }
    const expandItem = e => {
        columnExpandStateChangeCB(false);
        setIsCollapsed(false);
    }

    return (
    <div    className={"context--row-item " + (isHover ? 'context--row-item-hover' : '') }
            style={{outline: uniqueColor}}
            onMouseEnter={hoverStart}
            onMouseLeave={hoverEnd}
            >
            {isCollapsed?
                <button onClick={expandItem}>+</button>
            :
                <>
                    <button onClick={collapseItem}>-</button>
                    <table className='context--row-item-property-table'>
                        {_.keys(data).map((n) => <tr><td>{n}</td><td>{data[n]}</td></tr>)}
                    </table>
                </>
            }

    </div>
    );
}

function HorizontalContext({data}) {
    //const [data, setData] = React.useState(localHnc);
    return (
    <div>
        <h1>Horizontal Context</h1>
        {data.map(row =>
            <div className="context--row">
                {
                row.map(c => <HorizontalContextItem data={c.data} position={c} /> )
                }
            </div>
        )}
    </div>
    );
}

export default HorizontalContext;
export {HorizontalContext, HorizontalContextItem};